const Skills = () => {
  return (
    <section className="resume-section" id="skills">
      <div className="resume-section-content">
        <h2 className="mb-5">Skills</h2>
        <div className="subheading mb-3">Programming Languages & Tools</div>
        <table className="table w-100">
          <tbody>
            <tr>
              <td>
                <li>
                  <h3>Frontend tools</h3>
                  1.
                  <a href="https://www.w3.org/html/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg"
                      alt="html5"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.w3schools.com/css/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg"
                      alt="css3"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://tailwindcss.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg"
                      alt="tailwind"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                      alt="javascript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <br />
                  2.
                  <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                      alt="javascript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg"
                      alt="react"
                      width="40"
                      height="40"
                    />
                  </a>
                  <br />
                  {/* 3.
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://angular.io" target="_blank" rel="noreferrer">
                    <img
                      src="https://angular.io/assets/images/logos/angular/angular.svg"
                      alt="angular"
                      width="40"
                      height="40"
                    />
                  </a> */}
                </li>
              </td>
              <td>
                <li>
                  <h3>Backend tools</h3>
                  1.
                  <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                      alt="javascript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://nodejs.org/" target="_blank" rel="noreferrer">
                    <img src="https://nodejs.org/static/images/logo.svg" alt="typescript" width="40" height="40" />
                  </a>
                  <br />
                  2.
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="http://nestjs.com/" target="blank">
                    <img src="https://nestjs.com/img/logo-small.svg" width="40" height="40" alt="Nest Logo" />
                  </a>
                  <br />
                  3.
                  <a href="https://www.java.com" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
                      alt="java"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://spring.io/" target="_blank" rel="noreferrer">
                    <img
                      src="https://pbs.twimg.com/profile_images/1235868806079057921/fTL08u_H_400x400.png"
                      alt="java"
                      width="40"
                      height="40"
                    />
                  </a>
                </li>
              </td>
            </tr>
            <tr>
              <td>
                <li>
                  <h3>Mobile tools</h3>
                  1.
                  <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                      alt="javascript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
                      alt="typescript"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://reactnative.dev/" target="_blank" rel="noreferrer">
                    <img src="https://reactnative.dev/img/header_logo.svg" alt="reactnative" width="40" height="40" />
                  </a>
                  <br />
                  {/* 2.
                  <a href="https://dart.dev/" target="_blank" rel="noreferrer">
                    <img src="https://dart.dev/assets/shared/dart/icon/64.png" alt="dart" width="40" height="40" />
                  </a>
                  <a href="https://flutter.dev/" target="_blank" rel="noreferrer">
                    <img
                      src="https://storage.googleapis.com/cms-storage-bucket/4fd5520fe28ebf839174.svg"
                      alt="flutter"
                      width="40"
                      height="40"
                    />
                  </a> */}
                </li>
              </td>
              <td>
                <li>
                  <h3>Database tools</h3>
                  1.
                  <a href="https://www.mysql.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
                      alt="mysql"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.postgresql.org" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg"
                      alt="postgresql"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.sqlite.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://www.vectorlogo.zone/logos/sqlite/sqlite-icon.svg"
                      alt="sqlite"
                      width="40"
                      height="40"
                    />
                  </a>
                  <br />
                  2.
                  <a href="https://www.mongodb.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
                      alt="mongodb"
                      width="40"
                      height="40"
                    />
                  </a>
                  <br />
                  {/* 3.
                  <a href="https://firebase.google.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                      alt="firebase"
                      width="40"
                      height="40"
                    />
                  </a> */}
                </li>
              </td>
            </tr>
            <tr>
              <td>
                <li>
                  <h3>UI/UX</h3>
                  1.
                  <a href="https://www.figma.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://www.vectorlogo.zone/logos/figma/figma-icon.svg"
                      alt="figma"
                      width="40"
                      height="40"
                    />
                  </a>
                  {/* <a href="https://www.adobe.com/products/xd.html" target="_blank" rel="noreferrer">
                    <img src="https://cdn.worldvectorlogo.com/logos/adobe-xd.svg" alt="xd" width="40" height="40" />
                  </a> */}
                </li>
              </td>
              <td>
                <li>
                  <h3>Other tools and services</h3>
                  1.
                  <a href="https://www.arduino.cc/" target="_blank" rel="noreferrer">
                    <img
                      src="https://cdn.worldvectorlogo.com/logos/arduino-1.svg"
                      alt="arduino"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://git-scm.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"
                      alt="git"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://www.linux.org/" target="_blank" rel="noreferrer">
                    <img
                      src="https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg"
                      alt="linux"
                      width="40"
                      height="40"
                    />
                  </a>
                  <a href="https://firebase.google.com/" target="_blank" rel="noreferrer">
                    <img
                      src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                      alt="firebase"
                      width="40"
                      height="40"
                    />
                  </a>
                </li>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};
export default Skills;
